import styled from '@emotion/styled'
import {COLORS} from '../../constants'

/** Responsive grid of stat cells (2 columns, 3 from sm, 5 from lg). */
export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 16px;
  padding: 10px 16px;
  border-top: 1px solid ${COLORS.border};
  background-color: ${COLORS.mutedBg};

  @media (min-width: 600px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (min-width: 960px) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
`

/** A single labelled stat within the grid. */
export const StatCell = styled.div`
  min-width: 0;
`

/** Uppercase caption of a stat cell (may also host the fee tooltip trigger). */
export const StatLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${COLORS.mutedText};
`

/** Stat value; pass `green` to highlight monetary minimums in the success colour. */
export const StatValue = styled.div<{green?: boolean}>`
  margin-top: 2px;
  font-size: 13px;
  font-weight: 600;
  color: ${(props) => (props.green ? COLORS.success : COLORS.foreground)};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
